import * as Yup from "yup";

export const createLoginCredentialsSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    email: Yup.string()
      .min(5, t("validation.emailMinLength"))
      .max(100, t("validation.emailMaxLength"))
      .email(t("validation.invalidEmail"))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        t("validation.invalidEmailFormat"),
      )
      .test(
        "no-consecutive-dots",
        t("validation.noConsecutiveDots"),
        (value) => {
          if (!value) return true;
          return !value.includes("..");
        },
      )
      .test(
        "no-special-start-end",
        t("validation.noSpecialStartEnd"),
        (value) => {
          if (!value) return true;
          return (
            !value.startsWith(".") &&
            !value.endsWith(".") &&
            !value.startsWith("+") &&
            !value.startsWith("-")
          );
        },
      )
      .required(t("validation.emailRequired")),
    password: Yup.string()
      .min(8, t("validation.passwordMinLength"))
      .max(128, t("validation.passwordMaxLength"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
        t("validation.passwordComplexity"),
      )
      .test(
        "no-common-passwords",
        t("validation.noCommonPasswords"),
        (value) => {
          if (!value) return true;
          const commonPasswords = [
            "password",
            "123456",
            "password123",
            "admin",
            "qwerty",
            "letmein",
            "welcome",
            "monkey",
            "1234567890",
            "abc123",
          ];
          return !commonPasswords.includes(value.toLowerCase());
        },
      )
      .test("no-repeated-chars", t("validation.noRepeatedChars"), (value) => {
        if (!value) return true;
        // Vérifier qu'il n'y a pas plus de 3 caractères identiques consécutifs
        return !/(.)\1{3,}/.test(value);
      })
      .required(t("validation.passwordRequired")),
  });

export const createOTPSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    otp: Yup.string()
      .matches(/^\d{6}$/, t("validation.otpFormat"))
      .test("no-sequential", t("validation.noSequentialOTP"), (value) => {
        if (!value) return true;
        // Vérifier que ce n'est pas une séquence (123456, 654321, etc.)
        const sequences = [
          "123456",
          "654321",
          "000000",
          "111111",
          "222222",
          "333333",
          "444444",
          "555555",
          "666666",
          "777777",
          "888888",
          "999999",
        ];
        return !sequences.includes(value);
      })
      .required(t("validation.otpRequired")),
  });

// Backward compatibility
export const loginSchema = createLoginCredentialsSchema((key: string) => key);

export interface LoginCredentialsFormValues {
  email: string;
  password: string;
}

export interface OTPFormValues {
  otp: string;
}
